import React from "react";
import { Tabs, Form } from "antd";
import PropTypes from "prop-types";
import { useSelector } from 'react-redux';
import { AddUser } from '../../style';
import { BasicFormWrapper } from '../../../styled';
import { DetailsOtherInfoUser } from '../GlobalComponents/UserCardCmnts'
import CallButton from '../GlobalComponents/CallButton'
import CopyButton from '../GlobalComponents/CopyButton'

const LeadTabPage = ({ displayData, setNaCTrigger, arrayDisplayData }) => {
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    const excludedSPL = ["primaryEmail", "secondaryEmail", "linkedinUrl", "phone", "mobile"];
    const excludedLink = ["linkedinUrl"];
    const excludedCopy = ["primaryEmail", "secondaryEmail", "linkedinUrl"];
    const excludedCall = ["phone", "mobile"];
    const localData = useSelector((state) => state.localRedux);
    const defaultCurrency = localData.currency
    return (
        <AddUser>
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false}>
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div className="add-product-content">
                                <Tabs defaultActiveKey="1">
                                    {arrayDisplayData
                                        ?.filter(group => group.fields?.length > 0)
                                        .map((group, index) => (
                                            <TabPane
                                                tab={group.label || `Group ${index + 1}`}
                                                key={index + 1}
                                            >
                                                {group.fields.map((field) => (
                                                    <Form.Item
                                                        key={field.fieldId}
                                                        label={field.fieldType === "Currency" ? `${field.fieldLabel} (${defaultCurrency?.currency})` : (field.fieldType === "Percentage" ? `${field.fieldLabel} (%)` : field.fieldLabel)}
                                                        name={field.fieldKey}
                                                        className="custom-form-item"
                                                    >
                                                        <span className={excludedSPL.includes(field.fieldKey) ? "call-Optionholder" : ""}>
                                                            {(field?.value && field?.value !== "") ?
                                                                excludedLink.includes(field.fieldKey) ?
                                                                    <><a href={field?.value.startsWith("http") ? field?.value : `https://${field?.value}`}
                                                                        target="_blank" style={{ color: "#407fe9", textDecoration: "none", marginRight: 8 }} rel="noopener noreferrer">
                                                                        {field?.value} </a> <CopyButton apiKey={field?.value} type="URL" /></>
                                                                    : excludedCall.includes(field.fieldKey) ? <>
                                                                        <span>{field?.value}</span><CallButton number={field?.value} EntityData={{ type: "Lead", data: displayData, for: "Lead" }} setNaCTrigger={setNaCTrigger} /></>
                                                                        : excludedCopy.includes(field.fieldKey) ? <>
                                                                            <span>{field?.value}</span><CopyButton apiKey={field?.value} type="Email" /></>
                                                                            : field?.value
                                                                : null}
                                                        </span>
                                                    </Form.Item>
                                                ))}
                                            </TabPane>
                                        ))}
                                    <TabPane tab="Other Info" key={(arrayDisplayData?.filter(group => group.fields?.length > 0).length || 0) + 1}>
                                        <Form.Item label="Created By" className="custom-form-item" >
                                            {displayData?.created_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.created_by,
                                                    recordbyFName: displayData?.createdByFirstName,
                                                    recordbyLName: displayData?.createdByLastName,
                                                    date: displayData?.created_at
                                                }} />
                                                : <></>}
                                        </Form.Item>
                                        <Form.Item label="Modified By" className="custom-form-item">
                                            {displayData?.modified_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.modified_by,
                                                    recordbyFName: displayData?.modifiedByFirstName,
                                                    recordbyLName: displayData?.modifiedByLastName,
                                                    date: displayData?.modified_at
                                                }} /> : <></>}
                                        </Form.Item>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form >
            </div >
        </AddUser >
    )
}
LeadTabPage.propTypes = {
    displayData: PropTypes.object.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    arrayDisplayData: PropTypes.array.isRequired,
}
export default React.memo(LeadTabPage)
